import { Injectable } from '@angular/core'

import { APIService } from 'api/module'
import { TasksService } from 'tasks/services/tasks.service'
import { TranslateService } from '@ngx-translate/core'
import { NotifyService } from 'common/util/services/notify.service'

@Injectable({ providedIn: 'root' })
export class FilesystemService {
  constructor (
    private api: APIService,
    private tasks: TasksService,
    private notify: NotifyService,
    private translate: TranslateService,
  ) {
  }

  async renameFile (path: string, name: string): Promise<void> {
    const response = await this.api.storage.patchFile({
      path,
      filePartialUpdate: { name },
    })
    if (!response.tasks.length) {
      return
    }

    const process = this.notify.process(
      this.translate.instant('Renaming {name}', { name }),
    )

    try {
      await this.tasks.waitTasksComplete(response.tasks.map(t => t.id))
      this.notify.finishProcess(process, 'success')
    } catch (err) {
      this.notify.finishProcess(process, 'error')
      throw err
    }
  }
}
